module.exports = __webpack_public_path__ + "static/media/brahderlau_alt.daae97f4.jpg";